module.exports = __webpack_public_path__ + "static/media/tp.7aaebd66.png";